import React, { useEffect, useState } from 'react'
import Http from '../../Http';
import { useParams } from "react-router-dom";
import { CircularProgress, FormControlLabel, Snackbar, Switch, Button } from '@material-ui/core';

export default function RolAccess() {
   const [access, setAccess] = useState(null)
   const params = useParams();
   const id_rol = params.id;
   const [snack, setSnack] = useState({ visible: false, msg: null });
   const [loading, setLoading] = useState(false);

   useEffect(() => {
      loadAccess();
   }, [])

   const loadAccess = () => {
      const Res = Http.post('usuario-rol/access', { id_rol });
      Res.then(res => {
         if (res.data) {
            setAccess(res.data);
         } else {
            setSnack({ visible: true, msg: "Ocurrio un error cargando los Accesos (99)" })
         }
      }).catch(() => {
         setSnack({ visible: true, msg: "Ocurrio un error cargando los Accesos (99)" })
      })
   }

   const onAccesChange = (index, ind) => {
      setAccess(acc => {
         let newAcc = {
            ...acc
         };
         newAcc['access'][index]['access'][ind]['checked'] = !newAcc['access'][index]['access'][ind]['checked'];
         return newAcc;
      })
   }

   const onSave = () => {
      setLoading(true);
      let rolAccess = access.access.map(a => a.access.filter(a => a.checked).map(a => a.codigo));
      rolAccess = rolAccess.flat(1);
      const req = Http.post('usuario-rol/access/save', { id_rol, access: rolAccess });
      req.then(r => {
         if (r.data) {
            setSnack({ visible: true, msg: "Se guardo correctamente" })
         }
      }).catch(() => {
         setSnack({ visible: true, msg: "Ocurrio un error guardando los accessos" })
      }).finally(() => {
         setLoading(false)
      })
   }

   return (<div>

      {!access && (<div style={{ width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', height: 100, flexDirection: 'column' }} >
         <CircularProgress />
         <h3>Cargando...</h3>
      </div>)}

      {access && (<div style={{ padding: 10, display: 'flex', justifyContent: 'space-between' }} >
         <h2>Accesos:  {access.rol_nombre}</h2>
         <Button color='primary' variant="contained" disabled={loading} onClick={onSave} >
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }} >
               {loading && <CircularProgress style={{ marginRight: 5 }} size={20} />}
               Guardar
            </div>
         </Button>
      </div>)}

      {access && access.access.map((a, index) => (<div key={`${index}-${a.clave}`} style={{ width: '100%', display: 'flex', justifyContent: 'center', flexDirection: 'column', padding: 10 }} >
         <div style={{ borderBottom: '1px solid gray' }} >
            <h4>{a.clave}</h4>
         </div>
         <div className='content' style={{ width: '100%', display: 'flex', justifyContent: 'space-between', flexDirection: 'row', flexWrap: 'wrap' }} >
            {a.access.map((cod, ind) => <div key={cod.codigo} style={{ width: '50%', padding: 10 }} >
               <FormControlLabel
                  control={
                     <Switch
                        disabled={loading}
                        checked={cod.checked}
                        onChange={() => { onAccesChange(index, ind) }}
                        color="secondary"
                     />
                  }
                  label={`[${cod.codigo}]${cod.descripcion}`}
               />
            </div>)}
         </div>
      </div>))}

      <Snackbar
         open={snack.visible}
         autoHideDuration={6000}
         onClose={() => setSnack({ visible: false, msg: '' })}
         message={snack.msg}
      />
   </div>)
}
